export default __webpack_public_path__ + "static/media/sp-app-operation-01.e216f348.png";